import React, { ReactElement } from 'react';
import useStyles from './styles';
import { Control, DeepMap, FieldError } from 'react-hook-form';
import TranslatedText from '../../../../components/atoms/translated_text';
import { Translations, CanModify } from './configuration';
import { Typography } from '@material-ui/core';
import { AppDatePicker } from '../../../../components/molecules/form_controls';
import GridLayout from '../../../../components/molecules/grid_layout';
import { SchemeTypes } from '../../../../config';
import { FormFields } from '../../configuration';

interface IProps {
  mode: 'VIEW' | 'EDIT';
  scheme_type: SchemeTypes;
  is_agent: boolean;
  isExcluded: boolean;
  errors: DeepMap<FormFields, FieldError>;
  control: Control<FormFields>;
}

export default function ContactDetailsForm(props: IProps): ReactElement {
  // console.log('Render Contact Details Form');
  const classes = useStyles();
  const mode = props.mode;
  const SCHEME_TYPE = props.scheme_type;
  const IS_AGENT = props.is_agent;
  const errors = props.errors;
  const control = props.control;
  const isExcluded = props.isExcluded;

  return (
    <div>
      <Typography variant="h5">
        <TranslatedText textMap={Translations.first_supply_header} />
      </Typography>
      <GridLayout
        elements={[
          {
            element: renderDateOfSupplyField(
              errors,
              control,
              mode,
              SCHEME_TYPE,
              IS_AGENT,
              isExcluded
            ),
            size: 4,
            id: 'dateOfFirstSupply',
          },
        ]}
        justify="flex-start"
      />
    </div>
  );
}

const renderDateOfSupplyField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  mode: 'VIEW' | 'EDIT',
  SCHEME_TYPE: SchemeTypes,
  IS_AGENT: boolean,
  isExcluded: boolean
) => {
  return (
    <AppDatePicker
      fullWidth
      margin="normal"
      label={
        <TranslatedText textMap={Translations.date_of_first_supply_label} />
      }
      autoOk
      maxDate={new Date()}
      error={'firstSupplyDetails_dateOfFirstSupply' in errors}
      control={control}
      rules={{}}
      name="firstSupplyDetails_dateOfFirstSupply"
      helperText={
        errors.firstSupplyDetails_dateOfFirstSupply &&
        errors.firstSupplyDetails_dateOfFirstSupply.message
      }
      disabled={
        !CanModify[SCHEME_TYPE](IS_AGENT).includes(
          'firstSupplyDetails_dateOfFirstSupply'
        ) ||
        mode === 'VIEW' ||
        isExcluded
      }
    />
  );
};
